export const TRIP_DETAIL = {
  GIVEN_NAME: 'givenName',
  FAMILY_NAME: 'familyName',
  BOOKER_DETAIL: 'bookerDetail',
  GUEST_DETAIL: 'guestDetail',
  DIALING_CODE: 'dialingCode',
  MOBILE_NUMBER: 'mobileNumber',
  EMAIL: 'email',
  COUNTRY_CODE: 'countryCode',
  DEFAULT_COUNTRY_CODE: 'MY',
  NATIONALITY: 'nationality',
};
